export default "__VITE_ASSET__DJLPJfbY__"